import {parkList} from "@/api/overview";

export default {
  data() {
    return {
      parks: [],
      parkIndex: 0,
      currentPark: {},
      changePointTimer: null,
      loading: false,
    };
  },
  beforeDestroy() {
    if (this.changePointTimer) {
      clearInterval(this.changePointTimer);
    }
  },
  methods: {
    getParkList(pageType) {
      if (this.parks.length) return;
      this.loading = true;
      parkList()
        .then((res) => {
          this.parks = res.data.data;
          this.currentPark = this.parks[this.parkIndex];
          if (pageType === "center") {
            this.mapOpt.series[0].markPoint.data = this.parks.map((x, i) => {
              return {
                coord: [x.longitude, x.latitude],
                label: {
                  show: i === this.parkIndex,
                  position: "right",
                  color: "#fff",
                  padding: [8, 15],
                  fontSize: 14,
                  verticalAlign: "middle",
                  backgroundColor: {
                    image: `${location.protocol}//${location.host}/images/mapPoint.png`,
                  },
                },
                value: x.parkName,
              };
            });
            this.$nextTick(() => {
              this.$refs.mapChart.updateChart();
              this.getTodayGenAndStoPower();
              this.getDayGenAndStoEarn();
              this.getYearTotal();
              this.getChargingAndDischarging();
              // this.getEleAndIncome();
              // this.getEleAndIncomeByDate();
              this.getCarbonTotal();
              this.getPeakTip();
            });
          }
          if (pageType === "left") {
            this.$nextTick(() => {
              this.getGen30DayData();
              this.getStorage30DayData();
              this.getLoad30DayData();
            });
          }

          this.changePointTimer = setInterval(() => {
            this.loopPoint(pageType);
          }, 15000);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    loopPoint(pageType) {
      this.parkIndex = this.parkIndex + 1;
      if (this.parkIndex >= this.parks.length) {
        this.parkIndex = 0;
        this.mapOpt ? (this.mapOpt.series[0].markPoint.data[this.parks.length - 1].label.show = false) : null;
      } else {
        this.mapOpt ? (this.mapOpt.series[0].markPoint.data[this.parkIndex - 1].label.show = false) : null;
      }
      this.currentPark = this.parks[this.parkIndex];
      if (pageType === "center") {
        this.mapOpt.series[0].markPoint.data[this.parkIndex].label.show = true;
        this.$nextTick(() => {
          this.$refs.mapChart.updateChart();
          this.getTodayGenAndStoPower();
          this.getDayGenAndStoEarn();
          this.getYearTotal();
          this.getChargingAndDischarging();
          // this.getEleAndIncome();
          // this.getEleAndIncomeByDate();
          this.getCarbonTotal();
          this.getPeakTip();
        });
      }
      if (pageType === "left") {
        this.$nextTick(() => {
          this.getGen30DayData();
          this.getStorage30DayData();
          this.getLoad30DayData();
        });
      }
    },
  },
};
